module.exports = __webpack_public_path__ + "img/oztix-logo.c545f508.svg";